
export const formatToFixed3 = (value) => {
    if(value === null || value === 0) return 0;
    return parseFloat(value).toFixed(3);
}

export const formatToFixed = (value, fixed) => {
    if(value === null) return 0;    
    return parseFloat(value).toFixed(fixed??2);
}